import type { AccessibilityLabelProps, IconColorVariant } from '@frontend/web-react';
import { Icon, YStack } from '@frontend/web-react';
import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';
import type { ClassName } from '@frontend/web-utils';
import { concatClasses } from '@frontend/web-utils';

type HeaderButtonProps = AccessibilityLabelProps & {
  className?: ClassName;
  color?: IconColorVariant;
  iconName: IconName;
  onClick?: () => void;
  size?: number;
};

export const HeaderButton = ({
  accessibilityLabel,
  className,
  color,
  iconName,
  onClick,
  size = 20,
}: HeaderButtonProps) => {
  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    <YStack
      accessibilityLabel={accessibilityLabel}
      className={concatClasses(
        'bg-neutral-100 items-center justify-center size-[36px] rounded-full cursor-pointer active:opacity-70 transition-opacity',
        className,
      )}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
      <Icon color={color} name={iconName} size={size} />
    </YStack>
  );
};
